import api from './api';

const authService = {
  // Login
  login: async (username, password) => {
    const response = await api.post('/api/auth/login', {
      username,
      password,
    });
    
    if (response.data.success) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  },

  // Register
  register: async (userData) => {
    const response = await api.post('/api/auth/register', userData);
    return response.data;
  },

  // Logout - full page reload to clear all in-memory state
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = window.location.origin + '/login';
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is logged in
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
};

export default authService;